// extracted by mini-css-extract-plugin
export var cardsContainer = "cards-module--cardsContainer--0dc56";
export var ctaContainer = "cards-module--ctaContainer--3b567 related-products-module--ctaContainer--61c6d";
export var product = "cards-module--product--ebf3d";
export var stackedctaStyles = "cards-module--stackedctaStyles--615ac";
export var wideProduct = "cards-module--wideProduct--a2393";